import { Container, Stack, Text, Button, Loader, Group, Alert } from "@mantine/core";
import GatewayHeader from "./GatewayWrapper";
import { useDocument } from "react-firebase-hooks/firestore";
import { Customer } from "../shared/customer";
import { Link } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useContext } from "react";
import { CompanyContext } from "./CompanyGateway";
import { IconInfoCircle } from "@tabler/icons-react";

export default function CheckoutComplete() {

  const [user, loadingUser, _userError] = useAuthState(getAuth());
  const company = useContext(CompanyContext);

  const [customerSS, loadingCustomer, _customerError] = useDocument(user ? Customer.ref(company.id, user.uid) : null);

  if (loadingUser) {
    return <GatewayHeader step={null}><Loader /></GatewayHeader>
  }

  if (!user) {
    return <GatewayHeader step={null}>
      <Text>Please return to <Link to="/">Members home</Link> to login.</Text>
    </GatewayHeader>
  }


  const customer = customerSS?.data();

  // useEffect(() => {
  //   if(newCustomer && customer) {
  //     window.dataLayer.push({ ecommerce: null });
  //     window.dataLayer.push({
  //       event: "purchase",
  //       ecommerce: {
  //         value: customer.mrr/100,
  //         currency: customer.currency.toUpperCase(),
  //         transaction_id: customer.subscriptionId,
  //         items: [{item_id: customer.productId}]
  //       }
  //     });
  //   }
  // }, [newCustomer, customer]);

  if (!customer || loadingCustomer) {
    return <GatewayHeader step={4}>
      <Loader />
      Proccesing subscription please wait.
    </GatewayHeader>
  }

  return <GatewayHeader step={5}>
    <Container>
      <Stack>
        <Text fw="700">Welcome to {company.name}</Text>
        <Text>
          You will shortly receive your e-key and access info via WhatsApp, once you have this you&apos;re ready to book your first session.
        </Text>

        <Text c="orange">
          
        </Text>

        <Alert variant="light" color="blue" title="E-Key setup" icon={<IconInfoCircle />}>
          Make sure you have your ekey setup before booking your first session!
        </Alert>
        
        <Group>
          <Link to="/"><Button>BOOK A SESSION</Button></Link>
        </Group>

        <Text fw="700">The {company.name} Team</Text>
      </Stack>
    </Container>
  </GatewayHeader>
}